import { combineReducers } from "redux";
import { ModalsControlReducer } from "./AppSettingsReducer";

import { AuthReducer, UsersListReducer } from "./authReducers";
import { CrushAddReducer, CrushRemoveReducer } from "./crushReducers";
import { InterestsListReducer, ProfileDetailsReducer, ProfileListReducer, ProfileUpdateReducer } from "./profileReducers";

export default combineReducers({
  Auth: AuthReducer,
  UsersList: UsersListReducer,
  CrushAdd: CrushAddReducer,
  CrushRemove: CrushRemoveReducer,
  InterestsList: InterestsListReducer,
  ProfileDetails: ProfileDetailsReducer,
  ProfileUpdate: ProfileUpdateReducer,
  ProfileList: ProfileListReducer,
  ModalsControl: ModalsControlReducer
});
